import { render, staticRenderFns } from "./bp.vue?vue&type=template&id=6b147ea2"
import script from "./bp.vue?vue&type=script&lang=js"
export * from "./bp.vue?vue&type=script&lang=js"
import style0 from "./bp.vue?vue&type=style&index=0&id=6b147ea2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports